import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {

  constructor(private router: Router) {}


  @Input()
  blog_data

  blog_list

  comment_data

  path : string;
  showDeveloper = true;
  showCreateBlog = true;

  selectedBlogUrl : string;

  initials = ""
  first_name : string;
  last_name : string;
  selected_index : number = -1;

  ngOnInit(): void {
    this.path = this.router.url.slice(1)+'/Notes';
    this.blog_list = this.blog_data['blog_list'];
    this.initials = this.blog_data['first_name'].substring(0,1).toUpperCase() + this.blog_data['first_name'].substring(1,2).toLowerCase();
    this.first_name = this.camelize(this.blog_data['first_name'])
    this.last_name = this.camelize(this.blog_data['last_name'])
  }

   camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index)
    {
        return index == 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}



  addItem($event){
    this.showDeveloper  = !this.showDeveloper;
  }

  createBlog(){
    this.showCreateBlog = true;
  }

  selectBlog(index){
    this.showCreateBlog = false;
    this.selected_index = index ;
    console.log(this.selected_index);

    this.comment_data = {
      'username' : this.blog_data['username'],
      'blog_url': this.blog_list[index]['blog_url']
    };
    this.selectedBlogUrl = this.blog_list[index]['blog_url'];
  }


}
